module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-actions"
  }, [_c('button', {
    staticClass: "button is-success",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.viewBatch(_vm.rowData, _vm.rowIndex)
      }
    }
  }, [_vm._v("\n    View\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4022bfbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BatchActions.vue
// module id = 236
// module chunks = 1